import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const COOKIE_CONSENT_KEY = 'autoflow_cookie_consent';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const setConsent = (status) => {
    localStorage.setItem(
      COOKIE_CONSENT_KEY,
      JSON.stringify({ status, date: new Date().toISOString() })
    );
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[9999] p-3 md:p-5"
      data-testid="cookie-banner"
    >
      <div className="max-w-3xl mx-auto bg-slate-900 border border-slate-700/60 rounded-2xl p-4 md:p-5 shadow-2xl">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
          <p className="flex-1 text-sm text-slate-300 leading-relaxed">
            Usamos cookies esenciales para el funcionamiento del sitio.{' '}
            <Link
              to="/cookies"
              className="underline text-cyan-400 hover:text-cyan-300 transition-colors"
              data-testid="cookie-policy-link"
            >
              Mas informacion
            </Link>
          </p>
          <div className="flex items-center gap-2 shrink-0 w-full md:w-auto">
            <button
              onClick={() => setConsent('essential_only')}
              className="flex-1 md:flex-none px-4 py-2.5 text-sm font-medium text-slate-300 border border-slate-600 rounded-xl hover:bg-slate-800 transition-colors min-h-[44px]"
              data-testid="cookie-reject-btn"
            >
              Solo esenciales
            </button>
            <button
              onClick={() => setConsent('accepted')}
              className="flex-1 md:flex-none px-5 py-2.5 text-sm font-semibold bg-cyan-500 text-slate-900 rounded-xl hover:bg-cyan-400 transition-colors min-h-[44px]"
              data-testid="cookie-accept-btn"
            >
              Aceptar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
